import { ApolloConsumer } from '@apollo/client';
import React, { Component } from 'react';

export default function withApolloClient(WrappedComponent) {
  return class Wrapper extends Component {
    render() {
      return <ApolloConsumer>{(client) => <WrappedComponent apolloClient={client} {...this.props} />}</ApolloConsumer>;
    }
  };
}
